import path from "src/types/paths";

// In the order which they will be rendered in the sidebar
export interface IPath {
  label: string;
  path: path;
  subs?: { [key in string]?: string };
}
export const PATHS_MAP: { [key in path]: IPath } = {
  job: {
    path: "job",
    label: "Jobs",
    subs: {
      create: "job/create",
      detail: "job/:id",
      invite: "job/invite/:id",
      interview_detail: "job/interview/:id"
    }
  },
  interview: {
    path: "interview",
    label: "Interviews"
  },
  settings: {
    path: "settings",
    label: "Settings"
  },
  talent: {
    path: "talent",
    label: "Talent",
    subs: {
      detail: "talent/:id"
    }
  },
  ats: {
    path: "ats",
    label: "ATS",
    subs: {
      job_detail: "ats/job/:id"
    }
  },
  usage: {
    path: "usage",
    label: "Usage"
  }
};
